import USOpenBanner, {
  US_OPEN_BANNER_HEADLINE, US_OPEN_BANNER_TAGLINE, US_OPEN_CARD_OFFER, US_OPEN_BRAND_ICON, US_OPEN_LEARN_MORE_TEXT, US_OPEN_LEARN_MORE_LINK,
} from './USOpenBanner';

export {
  US_OPEN_BANNER_HEADLINE, US_OPEN_BANNER_TAGLINE, US_OPEN_CARD_OFFER, US_OPEN_BRAND_ICON, US_OPEN_LEARN_MORE_TEXT, US_OPEN_LEARN_MORE_LINK,
};
export default USOpenBanner;
